<script setup>
  import {inject, ref} from "vue";

  import ComponentAlert from "@components/Alerts/Alert.vue";
  import ComponentCard from "@components/Cards/Card.vue";
  import ComponentConfirmationDialog from "@components/Dialogs/ConfirmationDialog.vue";
  import {useForm, usePage} from "@inertiajs/vue3";
  import MergeAccountCreateSteps from "@pages/MergeAccount/Components/CreateSteps.vue";
  import {MedButton} from "@pharma4u/medicheck-components";
  import Auth from "@utils/Auth.js";

  defineOptions({
    name: "PagesMergeAccountCreate",
  });

  const privacy = inject("$privacy");
  const pageProperties = usePage().props;
  const refConfirmSave = ref(null);

  const form = useForm({
    client_id: pageProperties.client.id, // << that's the hashid
  });

  const save = () => {
    form.post(route("merge-account.store"), {
      preserveScroll: true,
      onSuccess: (page) => {
        if (page.props?.flash?.payload?.transfer_id) {
          // log out...
          let redirectUrl = route("merge-account.show", {transfer: page.props.flash.payload.transfer_id});
          let fullRedirectUrl = route("login") + "?redirect=" + redirectUrl;
          Auth.logout(privacy, fullRedirectUrl);
        } else {
          console.error(
            "No flash.payload.transfer_id was found in the page properties, therefore no RedirectUrl can be generated.",
          );
        }
      },
      onError: (error) => {
        console.error(error);
      },
    });
  };
</script>

<template>
  <div id="p4umc-merge-account" class="mb-4 max-w-(--breakpoint-xl)">
    <ComponentCard title="Accounts verknüpfen" :test-id="getTestId()">
      <section>
        <p class="mt-4">
          Mit dieser Funktion können Sie Ihren pharma4u-Account mit Ihren Warenwirtschaftsaccount verknüpfen.
          <br />
          So läuft der Vorgang ab:
        </p>

        <MergeAccountCreateSteps />

        <ComponentAlert type="info" class="mt-8">
          Sie erhalten nach Eingabe der Datenschutzpasswörter die voraussichtliche Verknüpfungsdauer. Sie können den
          Vorgang dann auch zu einem späteren Zeitpunkt starten.
        </ComponentAlert>

        <div class="mt-4 flex justify-center">
          <MedButton
            variant="primary"
            :data-test="getTestId('start-merge-button')"
            @click="() => refConfirmSave.open()"
          >
            Verknüpfung starten
          </MedButton>
        </div>
      </section>
    </ComponentCard>

    <ComponentConfirmationDialog
      ref="refConfirmSave"
      title="Sie werden nun ausgeloggt"
      content="Melden Sie sich direkt im Anschluss mit Ihrem zweiten Account an."
      @confirmed="() => save()"
    />
  </div>
</template>
